import { useState, useEffect } from 'react';

/**
 * Defers mounting its children until the browser is idle.
 * This keeps heavy/slow components (AI widgets, third-party SDKs) out of the
 * critical render path so the page shell paints instantly.
 *
 * Usage:
 *   <DeferredMount delay={400}><HeavyWidget /></DeferredMount>
 */
export default function DeferredMount({ children, delay = 300, fallback = null }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const ric = window.requestIdleCallback;
    let id;
    if (ric) {
      id = ric(() => setMounted(true), { timeout: delay + 1000 });
      return () => window.cancelIdleCallback?.(id);
    }
    id = setTimeout(() => setMounted(true), delay);
    return () => clearTimeout(id);
  }, [delay]);

  return mounted ? children : fallback;
}
